import React from 'react';
import { motion } from 'framer-motion';
import { WhatsAppButton } from './WhatsAppButton';
const HERO_IMAGE_DESKTOP = 'https://cdn.magicpatterns.com/patterns/generated-images/efc6aa9b-587b-47f2-b56a-ddba60050557.jpg';
const HERO_IMAGE_MOBILE = 'https://cdn.magicpatterns.com/patterns/generated-images/809f48b5-9104-4f4a-b69b-64e6ed39d342.jpg';
export function Hero() {
  return <section id="inicio" className="relative isolate overflow-hidden bg-emerald-800" data-id="element-31" data-mp="1297cu5rar3ad">
      <div role="img" aria-label="Cartas de tarot extendidas sobre lino marfil con velas encendidas, cristales y salvia" className="absolute inset-0 bg-cover bg-center bg-no-repeat lg:hidden" style={{
      backgroundImage: `url(${HERO_IMAGE_MOBILE})`
    }} data-id="element-32" data-mp="xae9h65q4snx" />
      <div aria-hidden="true" className="absolute inset-0 hidden bg-cover bg-center bg-no-repeat lg:block" style={{
      backgroundImage: `url(${HERO_IMAGE_DESKTOP})`
    }} data-id="element-33" data-mp="nekn6v27dksy" />
      <div className="absolute inset-0 bg-emerald-900/75" aria-hidden="true" data-id="element-34" data-mp="384jq2q4e53op" />

      <div className="relative mx-auto flex min-h-[520px] max-w-4xl flex-col justify-center px-5 py-16 text-center sm:min-h-[600px] sm:py-28 lg:px-8 lg:py-40" data-id="element-35" data-mp="3j9ainhg5sy79">
        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="text-[11px] font-semibold uppercase tracking-[0.28em] text-gold-300 sm:text-xs" data-id="element-36" data-mp="39b4ip5dwy251">
          Orientación espiritual y prácticas tradicionales en Estados Unidos
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.55,
        delay: 0.08
      }} className="mt-6 font-display text-3xl font-semibold leading-tight text-ivory-50 sm:text-5xl lg:text-6xl" data-id="element-37" data-mp="35aubxqiar7p4">
          Consulta gratuita con un experto en artes espirituales
        </motion.h1>

        <div className="hairline mx-auto mt-8 h-px w-40" aria-hidden="true" data-id="element-38" data-mp="2ljgyf6b5ppbq" />

        <motion.p initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.55,
        delay: 0.16
      }} className="mx-auto mt-8 max-w-2xl text-base leading-relaxed text-ivory-100 sm:text-lg" data-id="element-39" data-mp="s2b89zesml5o">
          Experiencia en prácticas tradicionales de brujería y hechicería.
          Ofrecemos consultas y prácticas espirituales personalizadas de
          acuerdo con cada situación.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.55,
        delay: 0.24
      }} className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row" data-id="element-40" data-mp="161t24t6y4olw">
          <WhatsAppButton label="¡Habla con el Brujo Mayor aquí!" variant="onEmerald" className="w-full sm:w-auto" data-id="element-41" data-mp="x0l50eg61tte" />
          <a href="#servicios" className="inline-flex w-full items-center justify-center rounded-sm border border-gold-300/70 px-6 py-3.5 text-sm font-semibold uppercase tracking-[0.12em] text-ivory-50 transition-colors hover:bg-ivory-50/10 sm:w-auto" data-id="element-42" data-mp="3hqu083qvfvy0">
            Ver servicios
          </a>
        </motion.div>

        <p className="mx-auto mt-8 max-w-xl text-xs leading-relaxed text-sage-100" data-id="element-43" data-mp="268ognz4bvzzx">
          Servicio exclusivo para mayores de edad. Consultas y prácticas
          espirituales de carácter personal y tradicional.
        </p>
      </div>
    </section>;
}